import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
})
export class ConfirmationModalComponent implements OnInit {
  readonly titleMaxChars = 100;
  readonly messageMaxChars = 100;

  @Input() confirmationTitle: any;
  @Input() confirmationSubtitle: any;
  @Input() confirmationMessage: any;
  @Input() noticeTitle: any;
  @Input() noticeMessage: any;
  @Input() actionText: any;
  @Input() cancelText: any;
  @Input() discardText: any;
  @Input() showActionButton = true;
  @Input() showCancel = false;
  @Input() showDiscardButton = false;
  @Input() showConfirmationCheckbox = false;
  @Input() confirmationCheckboxLabel = '';
  @Input('isConfirmationCheckboxChecked') initialConfirmationCheckboxChecked?: boolean;
  @Input() confirmationCheckboxChecked = true;
  @Input() keepTitleInSingleLine = false;
  @Input() useFullMessage = false;
  public isConfirmationCheckboxChecked = true;
  constructor(private modalController: ModalController) { }

  ngOnInit() {
    this.isConfirmationCheckboxChecked = this.initialConfirmationCheckboxChecked ?? this.confirmationCheckboxChecked;
  }

  public truncateWithEllipsis(value: any, maxChars: number): string {
    if (value === null || value === undefined) {
      return '';
    }

    const text = String(value);
    if (text.length <= maxChars) {
      return text;
    }

    return `${text.slice(0, maxChars)}...`;
  }

  public isTruncated(value: any, maxChars: number): boolean {
    if (value === null || value === undefined) {
      return false;
    }

    return String(value).length > maxChars;
  }

  /**
   * Closes modal on clicking close icon
   */
  public closeModal() {
    this.modalController.dismiss({
      isActionConfirmed: false,
      isConfirmationCheckboxChecked: this.isConfirmationCheckboxChecked,
      confirmationCheckboxChecked: this.isConfirmationCheckboxChecked,
    });
  }

  /**
   * Confirms confirmation modal component
   */
  public confirm() {
    this.modalController.dismiss({
      isActionConfirmed: true,
      isConfirmationCheckboxChecked: this.isConfirmationCheckboxChecked,
      confirmationCheckboxChecked: this.isConfirmationCheckboxChecked,
      dismissed: true,
    });
  }

  /**
   * Dismisses the modal with a discard result (distinct from cancel/close)
   */
  public discard() {
    this.modalController.dismiss({
      isActionConfirmed: false,
      isDiscarded: true,
      isConfirmationCheckboxChecked: this.isConfirmationCheckboxChecked,
      confirmationCheckboxChecked: this.isConfirmationCheckboxChecked,
    });
  }

}
